export const randomElementFromArray = <T>(array: T[]) => {
  const randomIndex = Math.ceil(Math.random() * array.length - 1);
  return array[randomIndex];
};

export const capitalizeToKebabCase = (text: string) => {
  return text.toLowerCase().replaceAll(' ', '-');
};
